module.exports = __webpack_public_path__ + "static/a_lu-cf78a39b45120f9e7a8eded685cb24fe.jpeg";